/* src/app/ships/round-trips/fleet-information/fleet-information.component.css */
.save-panel {
  margin-top: -10px;
  margin-right: -15px;
}
input.ng-invalid.ng-touched {
  border: 1px solid red;
}
/*# sourceMappingURL=fleet-information.component.css.map */
